import React from 'react'
import PropTypes from 'prop-types'
import { createPortal } from 'react-dom';

import './style.scss'

const Modal = ({ show, children }) =>
    show ? (
        <div className='modal_container' >
            <div className='modal_overlay' />
            <div className='modal_'>
                {children}
            </div>
        </div>
    ) : null
Modal.propTypes = {
    show: PropTypes.bool,
    children: PropTypes.node
}

const Portal = (props) => createPortal(<Modal {...props} />, document.body)

export default Portal
